import type { RouteLocationNormalized } from 'vue-router'

const APP_NAME = import.meta.env.VITE_APP_NAME

export function setPageTitle(to: RouteLocationNormalized): void {
  const title = to.meta.title as string | undefined
  document.title = title ? `${title} | ${APP_NAME}` : APP_NAME
}
